module.exports = __webpack_public_path__ + "img/huawei.a5a558c1.png";